import Profile from '../../account/Profile';

const OrgProfile = () => {
  return <Profile redirectTo="/hub/settings" />;
};

export default OrgProfile;